import moment from 'moment';

export const getBetSlipTopics = (betBasketsRef) => {
    if (!window.bsConfig || !window.fbConfig) return false;
    let topics = [];
    betBasketsRef.current?.forEach((betLines) => {
        betLines?.forEach((betLine) => {
            let curTopics = [];
            if (betLine.prod == 'HR') {
                curTopics = getRacingTopics(betLine);
            } else if (betLine.prod == 'FB') {
                curTopics = getFootballTopics(betLine);
            }
            betLine.topics = [...new Set(curTopics)].sort();
            topics = [...topics, ...curTopics];
        });
    });
    return [...new Set(topics)].sort();
};

const getRacingTopics = (betLine) => {
    const { betObj } = betLine;
    const { betType } = betObj;
    let poolList = [];
    if (['JKC', 'TNC'].includes(betType)) {
        let pushStr = '';
        const {
            pushTopics: { RACING_FO_ODDS }
        } = window.bsConfig;
        const {
            id,
            currentPool: { poolId },
            venueid
        } = betObj;
        const dt = id.split('_')[1];
        pushStr = RACING_FO_ODDS.replace('{dt}', dt)
            .replace('{ve}', venueid.toLowerCase())
            .replace('{btyp}', betType.toLowerCase())
            .replace('{poolId}', poolId);
        poolList.push(pushStr);
    }
    return poolList;
};
const getFootballTopics = (betLine) => {
    const { betObj } = betLine;
    const { betType } = betObj;

    let poolList = [];
    let msgStr = [];
    if (betType == 'ALUP') {
        betLine.betObj.betList?.forEach((item) => {
            msgStr = footBallSingleBet(item);
            poolList = [...poolList, ...msgStr];
        });
    } else {
        msgStr = footBallSingleBet(betObj);
        poolList = [...poolList, ...msgStr];
    }
    return poolList;
};

const footBallSingleBet = (betObj) => {
    const { AllTournamentOrder } = window.fbConfig;
    const {
        pushTopics: { MATCH_POOL_UP, MATCH_POOL_UP_V2, MATCH_POOL_ODDS_V2, TOURNAMENT_POOL_UP, TOURNAMENT_POOL_UP_V2, TOURNAMENT_POOL_ODDS_V2, MATCH_UP, TOURNAMENT_UP, TOURNAMENT_UP_V2 }
    } = window.bsConfig;
    const { combs, matchInfo, tournInfo,  matchId } = betObj;
    const tournId = matchInfo?.tournament ? matchInfo?.tournament?.id : tournInfo ? tournInfo?.id : matchId;
    let betList = [];
    if (matchInfo) {
        let topic = window.globalConfig.ODDS_PUSH_V2 ? MATCH_UP.replace('evt/01/','evt/02/') : MATCH_UP
        betList.push(footBallPoolReplace(topic, { tournId, matchId: matchInfo.id }));
    }
    if (tournInfo) {
        if(window.globalConfig.ODDS_PUSH_V2){
            betList.push(footBallPoolReplace(TOURNAMENT_UP_V2.replace("{subType}",'chlInfo'), { tournId: tournInfo.id }));
            betList.push(footBallPoolReplace(TOURNAMENT_UP_V2.replace("{subType}",'genrl'), { tournId: tournInfo.id }));
            betList.push(footBallPoolReplace(TOURNAMENT_UP_V2.replace("{subType}",'dtl'), { tournId: tournInfo.id }));
        }else{
            betList.push(footBallPoolReplace(TOURNAMENT_UP, { tournId: tournInfo.id }));
        }
         
    }
    combs.forEach((comb) => {
        const { poolId, matchId, betType } = comb;
        const params = {
            tournId,
            betType,
            poolId,
            matchId
        };
        if (AllTournamentOrder.includes(betType)) {
            let topic = window.globalConfig.ODDS_PUSH_V2 ? TOURNAMENT_POOL_UP_V2 : TOURNAMENT_POOL_UP
            betList.push(footBallPoolReplace(topic, params));
            if(window.globalConfig.ODDS_PUSH_V2){
                betList.push(footBallPoolReplace(TOURNAMENT_POOL_ODDS_V2, params))
            }
        } else {
            let topic = window.globalConfig.ODDS_PUSH_V2 ? MATCH_POOL_UP_V2 : MATCH_POOL_UP
            betList.push(footBallPoolReplace(topic, params));
            if(window.globalConfig.ODDS_PUSH_V2){
                betList.push(footBallPoolReplace(MATCH_POOL_ODDS_V2, params))
            }
        }
    });
    return betList;
};

const footBallPoolReplace = (poolStr, { tournId, betType, poolId, matchId }) => {
    return poolStr
        .replace('{tournId}', tournId)
        .replace('{matchId}', matchId)
        .replace('{btyp}', betType?.toLowerCase())
        .replace('{poolId}', poolId);
};

export const hasHideOdds = (betLine, newPool) => {
    return false;
};

const getOddsDiff = (comb) => {
    const { oddsVal, oldOdds } = comb;
    if (isNaN(oldOdds) || isNaN(oddsVal)) {
        return 0;
    }
    const oddsDiff = parseFloat(oddsVal) - parseFloat(oldOdds);

    return oddsDiff;
};

export const isOddsUpdated = (comb) => {
    return getOddsDiff(comb) != 0;
};

export const checkPreviewBetOddsUpdated = (data) => {
    if (data.betObj.isStopSell) {
        return false;
    }
    if (data.betObj.betType == 'ALUP') {
        return data.betObj.betList.some((betItem) => {
            return betItem.combs.some((comb) => isOddsUpdated(comb));
        });
    } else {
        return data.betObj.combs.some((comb) => isOddsUpdated(comb));
    }
};

export const getPreviewOddsArrowCss = (comb) => {
    if (comb.isStopSell) return '';
    
    const { oddsVal, oldOdds } = comb;
    if (isNaN(oldOdds) || isNaN(oddsVal)) {
        return '';
    }
    const oddsDiff = parseFloat(oddsVal) - parseFloat(oldOdds);
    if (oddsDiff > 0) return 'oddsUp';
    if (oddsDiff < 0) return 'oddsDown';
    return '';
};

const showDiffTime = 2;

export const getOddsArrowCss = (comb, hide) => {
    if (hide) return '';
    // if (comb.isStopSell) return '';

    const { oddsVal, oldOdds, oddsUpdTs } = comb;
    if (isNaN(oldOdds) || isNaN(oddsVal) || !oddsUpdTs) {
        return '';
    }
    const oddsDiff = parseFloat(oddsVal) - parseFloat(oldOdds);
    const now = moment();
    const showDiff = oddsDiff != 0 && now.diff(oddsUpdTs, 'second') <= showDiffTime * 60;
    if (showDiff) {
        if (oddsDiff > 0) return 'oddsUp';
        else if (oddsDiff < 0) return 'oddsDown';
    }
    return '';
};

export const isDimBetLine = (st) => {
    return ['SUSPENDED', 'CLOSED'].includes(st);
};

export const isAvailableBetLine = (st) => {
    return st === 'SELLING' || st === undefined;
};

export const getBetLineCombSt = ({ pool, comb, isNormalStatus, isInteractiveServiceAvailable }) => {
    let sellStatus = 'CLOSED';
    if (isNormalStatus) {
        switch (pool?.status) {
            case 'SELLINGSTARTED':
                if (comb?.status == 'UNAVAILABLE' || !isInteractiveServiceAvailable) {
                    sellStatus = 'SUSPENDED';
                } else {
                    sellStatus = 'SELLING';
                }
                break;
            case 'SELLINGSTOPPED':
            case 'HOLD':
                sellStatus = 'SUSPENDED';
                break;
        }
        return sellStatus;
    }
    return sellStatus;
};

export const isRefundOrEliminated = (sellStatus, newCombination, pool) => {
    let poolStatus = pool?.status
    if(!poolStatus|| !sellStatus || !newCombination) return
    let selectionSt;
    if (sellStatus == 'CLOSED') {
        if (['ELIMINATED', 'IRRATIONAL'].includes(newCombination?.status)) {
            if(["NGS", "AGS"].includes(pool?.oddsType)) return null
            selectionSt = 'ELIMINATED';
        } else if (newCombination.status.includes('REFUND') && !poolStatus.includes('REFUND')) {
            selectionSt = 'REFUND';
        }
    }

    return selectionSt;
};

export const allupCombCompare = (a, b) =>{
        if(a.combId != b.combId) return  a.combId - b.combId;
        const aMain = a.currentPool.lines.find(i => i.lineId == a.lineId).main
        const bMain = b.currentPool.lines.find(i => i.lineId == b.lineId).main
    
        if(aMain && !bMain){
            return -1
        }else if(!aMain && bMain ){
            return 1
        }
        return a.oddsVal - b.oddsVal
}

export const updateOldOdds = (item, newCombination, oldCombObj, isSameOdds) =>{
    if (
        window.globalConfig.ENABLE_BET_ACCEPTANCE_PARSE2 || window.isReallyShowPreviewInfoTab
    ) {
        if(item.sellStatus === "SELLING") {
            if(item.lastSellingOddsVal) {
                if(item.lastSellingOddsVal === newCombination?.currentOdds) {
                    item.oldOdds = window.isReallyShowPreviewInfoTab ? item.lastSellingOldOdds : item.lastSellingOddsVal;
                } else {
                    item.oldOdds = item.lastSellingOddsVal
                }
                
            } else {
                item.oldOdds = isSameOdds ? item.oldOdds :  oldCombObj.oddsVal
            }
            item.lastSellingOldOdds = undefined
            item.lastSellingOddsVal = undefined
        } else if(item.lastSellingOddsVal === undefined){
            item.lastSellingOldOdds = item.oldOdds ? item.oldOdds : oldCombObj.oddsVal
            item.lastSellingOddsVal = oldCombObj.oddsVal
        }
    } else {
        item.oldOdds = isSameOdds ? item.oldOdds :  oldCombObj.oddsVal;
        item.lastSellingOldOdds = undefined;
        item.lastSellingOddsVal = undefined;
    }
}

export const getCountOfferOddsArrowCss = (comb) => {
    const newOdds = comb.oddsVal;
    const oldOdds = comb.oldOddsVal;
    if (isNaN(oldOdds) || isNaN(newOdds)) {
        return '';
    }
    const oddsDiff = parseFloat(newOdds) - parseFloat(oldOdds);
    if (oddsDiff > 0) return 'oddsUp';
    if (oddsDiff < 0) return 'oddsDown';
    return '';
};

export const getOddsUpdTs = ({
    updatedCombinationItem, isSameOdds, oldSellStatus
}) => {
    if (isDimBetLine(updatedCombinationItem.sellStatus)) {
        return null;
    }

    if (isDimBetLine(oldSellStatus)) {
        if (updatedCombinationItem.oldOdds === updatedCombinationItem.oddsVal) {
            return null;
        }
            return moment();
    }

    if (isSameOdds) {
        return updatedCombinationItem.oddsUpdTs;
    }

    return moment();
};